/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateSigintSignalForm,
  CreateSigintSignalForm$Outbound,
  CreateSigintSignalForm$outboundSchema,
} from "../components/createsigintsignalform.js";

export type CreateSigintSignalSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateSigintSignalSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateSigintSignalSecurity = {
  option1?: CreateSigintSignalSecurityOption1 | undefined;
  option2?: CreateSigintSignalSecurityOption2 | undefined;
};

export type CreateSigintSignalRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createSigintSignalForm: CreateSigintSignalForm;
};

/** @internal */
export type CreateSigintSignalSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateSigintSignalSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateSigintSignalSecurityOption1$Outbound,
  CreateSigintSignalSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createSigintSignalSecurityOption1ToJSON(
  createSigintSignalSecurityOption1: CreateSigintSignalSecurityOption1,
): string {
  return JSON.stringify(
    CreateSigintSignalSecurityOption1$outboundSchema.parse(
      createSigintSignalSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateSigintSignalSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateSigintSignalSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateSigintSignalSecurityOption2$Outbound,
  CreateSigintSignalSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createSigintSignalSecurityOption2ToJSON(
  createSigintSignalSecurityOption2: CreateSigintSignalSecurityOption2,
): string {
  return JSON.stringify(
    CreateSigintSignalSecurityOption2$outboundSchema.parse(
      createSigintSignalSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateSigintSignalSecurity$Outbound = {
  Option1?: CreateSigintSignalSecurityOption1$Outbound | undefined;
  Option2?: CreateSigintSignalSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateSigintSignalSecurity$outboundSchema: z.ZodMiniType<
  CreateSigintSignalSecurity$Outbound,
  CreateSigintSignalSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateSigintSignalSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateSigintSignalSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createSigintSignalSecurityToJSON(
  createSigintSignalSecurity: CreateSigintSignalSecurity,
): string {
  return JSON.stringify(
    CreateSigintSignalSecurity$outboundSchema.parse(createSigintSignalSecurity),
  );
}

/** @internal */
export type CreateSigintSignalRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateSigintSignalForm: CreateSigintSignalForm$Outbound;
};

/** @internal */
export const CreateSigintSignalRequest$outboundSchema: z.ZodMiniType<
  CreateSigintSignalRequest$Outbound,
  CreateSigintSignalRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createSigintSignalForm: CreateSigintSignalForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createSigintSignalForm: "CreateSigintSignalForm",
    });
  }),
);

export function createSigintSignalRequestToJSON(
  createSigintSignalRequest: CreateSigintSignalRequest,
): string {
  return JSON.stringify(
    CreateSigintSignalRequest$outboundSchema.parse(createSigintSignalRequest),
  );
}
